import { mapGetters, mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { SET_ACTIVE_BENEFIT_CATEGORY_INDEX } from '@store/modules/memberManagement/mutationTypes'

export default {
  created () {
    this.setActiveBenefitCategoryIndex(0)
  },
  watch: {
    '$route' (newRoute, oldRoute) {
      this.setActiveBenefitCategoryIndex(0)
    }
  },

  methods: {
    ...mapMutations({
      setActiveBenefitCategoryIndex: SET_ACTIVE_BENEFIT_CATEGORY_INDEX
    })
  },

  computed: {
    ...mapGetters(['memberDetails']),
    ...mapFields(['memberManagement.activeBenefitCategoryIndex']),

    benefits () {
      return this.memberDetails.benefits
    },

    activeBenefitCategory () {
      if (!this.benefits || Object.keys(this.benefits).length === 0 || !this.benefits.benefitDisplayCategories || !this.benefits.benefitDisplayCategories[this.activeBenefitCategoryIndex]) {
        return {}
      }
      return this.benefits.benefitDisplayCategories[this.activeBenefitCategoryIndex]
    }
  }
}
